import getStudentModule from './student.module'

export default getStudentModule
